import axios from "axios";
import environment from './environments/index';

const instance = axios.create({
  baseURL: environment.api.auth,
});

instance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    const compareURL = `${instance.defaults.baseURL}/oauth/token`;
    if (error?.response?.status === 401 && error?.response?.config?.url !== "/oauth/token") {
      const baseURL = window.location.origin;
      localStorage.removeItem("access-RefreshToken-Edify");
      localStorage.removeItem("access-Token-Edify");
      window.location.replace(baseURL)

    }
    return Promise.reject(error);
  }
);

export default instance;
